<script lang="ts">
  import CtaButton from '../Generic/CtaButton.svelte'
  import { firebase_user } from '../Users/observables'
  import { sendEmailVerification } from 'firebase/auth'
  import type { User } from 'firebase/auth'
  let sendingEmail = false
  let emailSent = false
  const sendEmail = async (firebase_user: User) => {
    sendingEmail = true
    await sendEmailVerification(firebase_user, {
      url: document.location.toString(),
    })
    emailSent = true
  }
</script>

{#if !$firebase_user || $firebase_user === null}
  <p>There was a problem with the user</p>
{:else}
  <p>Please Verify Your Email Address. Hit the button below to send a verification email.</p>

  <CtaButton on:click={() => sendEmail($firebase_user)} disabled={sendingEmail}>
    Send Verification Email
  </CtaButton>

  {#if emailSent}
    <h3>
      Email has been sent to {$firebase_user.email}, please check your spam folders if you have not received
      it.
    </h3>
  {/if}
{/if}
